import MuiTooltip, { TooltipProps as MuiTooltipProps, tooltipClasses } from '@mui/material/Tooltip';
import styled, { DefaultTheme } from 'styled-components';

export interface TooltipProps extends MuiTooltipProps {
	colourMode?: 'light' | 'dark';
}

const lightModelStyles = (theme: DefaultTheme) => ({
	[`& .${tooltipClasses.tooltip}`]: {
		backgroundColor: theme.palette.background.paper,
		color: theme.palette.text.primary,
		boxShadow: theme.shadows[1]
	},
	[`& .${tooltipClasses.arrow}`]: {
		color: theme.palette.background.paper,
		'&:before': {
			boxShadow: theme.shadows[1]
		}
	}
});

/** Styled Tooltip for light mode; defaults to Material-UI styles for dark mode */
const StyledTooltip = styled(({ className, colourMode, ...props }: TooltipProps) => <MuiTooltip {...props} classes={{ popper: className }} />)(
	({ theme, colourMode }) => ({
		...(colourMode === 'light' ? lightModelStyles(theme) : {})
	})
);

/**
 * A tooltip is a simple title or description that appears when hovering over an element.
 * For anything more complex than a short string of text, our Popover component should be used.
 */
export const Tooltip = (props: TooltipProps) => {
	const { colourMode = 'dark', children, ...rest } = props;

	return (
		<StyledTooltip colourMode={colourMode} arrow={props.arrow ?? true} {...rest}>
			{children}
		</StyledTooltip>
	);
};
